import { gql } from 'graphql-tag';
export const responsesForQuestion = gql`
  query responsesForQuestion(
    $surveyId: ID!
    $questionId: ID!
    $page: Int!
    $pageSize: Int!
    $searchPhrase: String
    $isSolutions: Boolean
    $includeSuggestedTags: Boolean
    $sortBy: OecResponseSortBy
    $filterByTaggedStatus: OecResponseFilterByTaggedStatus
    $selectedThemes: [ID!]
    $selectedStimuli: [ID!]
    $selectedSentiment: [OecSentiment!]
  ) {
    getOecResponses(
      surveyId: $surveyId
      questionId: $questionId
      page: $page
      pageSize: $pageSize
      searchPhrase: $searchPhrase
      isSolutions: $isSolutions
      includeSuggestedTags: $includeSuggestedTags
      selectedThemes: $selectedThemes
      selectedStimuli: $selectedStimuli
      sortBy: $sortBy
      filterByTaggedStatus: $filterByTaggedStatus
      selectedSentiment: $selectedSentiment
    ) {
      saStats {
        negative
        neutral
        positive
        undetected
      }
      totalCount
      optedIn
      saEnabled
      items {
        id
        stimulusId
        respondentId
        questionId
        optionId
        stimulus
        content
        tagIds
        createdAt
        suggestedTags
        sentiment
      }
    }
  }
`;